import { render, staticRenderFns } from "./DocumentLibrary.vue?vue&type=template&id=7116f68a"
import script from "./DocumentLibrary.vue?vue&type=script&lang=js"
export * from "./DocumentLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports